import { render, staticRenderFns } from "./preview-challenge.vue?vue&type=template&id=19b5e91f&scoped=true&"
import script from "./preview-challenge.vue?vue&type=script&lang=js&"
export * from "./preview-challenge.vue?vue&type=script&lang=js&"
import style0 from "./preview-challenge.vue?vue&type=style&index=0&id=19b5e91f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b5e91f",
  null
  
)

export default component.exports